/*
 * @Description:
 * @Author: lijinpeng
 * @Date: 2024-06-28 18:01:12
 * @LastEditTime: 2024-07-01 09:52:06
 * @LastEditors: lijinpeng
 */
import Axios from 'axios';

import JSON_BIG from 'json-bigint';

// 创建axios实例
const service = Axios.create({
  baseURL: process.env.VUE_APP_BASIC_NOTIFY,
  timeout: 600000,
  withCredentials: false, // 允许发送包含凭据（如 Cookies）的请求
  headers: {
    // 'Access-Control-Allow-Origin': '*',
    // 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    // 'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
    'Content-Type': 'application/json;charset=UTF-8',
    // 'Request-Source': 'ONE_STOP_WEB',
  },
  transformResponse: data => {
    try {
      return JSON_BIG.parse(data);
    } catch (err) {
      return JSON.parse(data);
    }
  },
});

// 添加响应拦截器
service.interceptors.response.use(res => {
  return res.data;
});

// 获取广播内容
export function getNotifyAnnouncement() {
  return service.get('/rest/notify/announcement', {
    params: {
      source: 'ONE_STOP_WEB',
    },
  });
}
